export class Chronology {
    articleId?: number;
    constructor(data?: Chronology) {
        this.articleId = data?.articleId;
    }
}

export class MapFilter {
    search?: string;
    filters?: string[];
    constructor(data?: MapFilter) {
        this.search = data?.search;
        this.filters = data?.filters;
    }
}